import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {ClipboardCheck, BarChart3, Target, ArrowRight} from 'lucide-react'

const niveis = [
  { level: "A1", name: "Iniciante", desc: "Compreende e usa expressões familiares e cotidianas. Consegue se apresentar e fazer perguntas básicas.", color: "#6CC4C4" },
  { level: "A2", name: "Básico", desc: "Compreende frases e expressões frequentes. Consegue comunicar-se em tarefas simples e rotineiras.", color: "#0E8EA0" },
  { level: "B1", name: "Intermediário", desc: "Compreende os pontos principais de assuntos familiares. Consegue lidar com situações de viagem e trabalho.", color: "#F5C542" },
  { level: "B2", name: "Intermediário Avançado", desc: "Compreende textos complexos. Consegue interagir com fluência e naturalidade com falantes nativos.", color: "#B038B2" },
  { level: "C1", name: "Avançado", desc: "Compreende textos longos e exigentes. Consegue expressar-se de forma fluente e espontânea.", color: "#0E8EA0" },
  { level: "C2", name: "Proficiente", desc: "Compreende praticamente tudo. Consegue expressar-se espontaneamente com precisão e fluência total.", color: "#B038B2" },
]

const steps = [
  { icon: ClipboardCheck, title: "Faça o teste", text: "Responda questões de listening, reading, grammar e vocabulary em poucos minutos." },
  { icon: BarChart3, title: "Receba seu resultado", text: "Descubra seu nível atual no quadro europeu de referência (CEFR) de A1 a C2." },
  { icon: Target, title: "Comece a estudar", text: "Receba um plano de estudos personalizado baseado no seu nível e objetivos." },
]

export default function TesteDeNivel() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Teste de Nível"
        subtitle="Descubra seu nível de inglês gratuitamente e receba um plano de estudos personalizado."
      />

      {/* Como funciona */}
      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-12" style={{ color: "#0E8EA0" }}>
            Como funciona
          </h2>
          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {steps.map((item, i) => (
              <div key={item.title} className="text-center">
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5"
                  style={{ backgroundColor: "#0E8EA015" }}
                >
                  <item.icon size={28} style={{ color: "#0E8EA0" }} />
                </div>
                <div className="text-xs font-bold text-gray-400 mb-2">PASSO {i + 1}</div>
                <h3 className="text-lg font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
          <div className="text-center">
            <a
              href="#"
              className="inline-flex items-center gap-2 px-8 py-4 text-white font-bold rounded-full text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
              style={{ backgroundColor: "#B038B2" }}
            >
              Fazer o teste agora <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>

      {/* Níveis */}
      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4" style={{ color: "#0E8EA0" }}>
            Quadro de Níveis (CEFR)
          </h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            O Quadro Europeu Comum de Referência para Línguas (CEFR) é o padrão internacional para descrever habilidades linguísticas.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {niveis.map((item) => (
              <div key={item.level} className="bg-white rounded-2xl p-6 border border-gray-100 hover:shadow-lg transition-all duration-300">
                <div className="flex items-center gap-3 mb-3">
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center text-white font-black text-lg"
                    style={{ backgroundColor: item.color }}
                  >
                    {item.level}
                  </div>
                  <h3 className="text-base font-bold text-gray-900">{item.name}</h3>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
